import {savePickgroupconfig,removePickgroupconfig,adjustPickgrouPriority,modifyPickgroupconfig,pagePickgroupconfig,queryPickgroupconfig,
  saveDynamicareaconfig,removeDynamicareaconfig,getDynamicareaconfig,modifyDynamicareaconfig,pageDynamicareaconfig,
  removePickgrouparea,addPickgrouparea,adjustPickgrouparea,pagePickgrouparea,verifyDelete
} from '@/services/internal/facility/DynamicPickupGroup';

export default {
  namespace: 'dynamicPickupGroup',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/facility/dynamicPickupGroup") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    entity: {},
    showPage: 'query'
  },
  effects: {
    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
        entityCode: payload.entityCode
      });
    },
    *removePickgroupconfig({payload,callback},{call, put}){
      const response = yield call(removePickgroupconfig, payload);
      if (callback) callback(response);
    },
    *savePickgroupconfig({payload,callback},{call, put}){
      const response = yield call(savePickgroupconfig, payload);
      if (callback) callback(response);
    },
    *adjustPickgrouPriority({payload,callback},{call, put}){
      const response = yield call(adjustPickgrouPriority, payload);
      if (callback) callback(response);
    },
    *modifyPickgroupconfig({payload,callback},{call, put}){
      const response = yield call(modifyPickgroupconfig, payload);
      if (callback) callback(response);
    },
    *pagePickgroupconfig({payload,callback},{call, put}){
      const response = yield call(pagePickgroupconfig, payload);
      if (callback) callback(response);
    },
    *queryPickgroupconfig({payload,callback},{call, put}){
      const response = yield call(queryPickgroupconfig, payload);
      if (callback) callback(response);
    },
    *pagePickgrouparea({payload,callback},{call, put}){
      const response = yield call(pagePickgrouparea, payload);
      if (callback) callback(response);
    },
    *saveDynamicareaconfig({payload,callback},{call, put}){
      const response = yield call(saveDynamicareaconfig, payload);
      if (callback) callback(response);
    },
    *removeDynamicareaconfig({payload,callback},{call, put}){
      const response = yield call(removeDynamicareaconfig, payload);
      if (callback) callback(response);
    },
    *getDynamicareaconfig({payload,callback},{call, put}){
      const response = yield call(getDynamicareaconfig, payload);
      if (callback) callback(response);
    },
    *modifyDynamicareaconfig({payload,callback},{call, put}){
      const response = yield call(modifyDynamicareaconfig, payload);
      if (callback) callback(response);
    },
    *pageDynamicareaconfig({payload,callback},{call, put}){
      const response = yield call(pageDynamicareaconfig, payload);
      if (callback) callback(response);
    },
    *addPickgrouparea({payload,callback},{call, put}){
      const response = yield call(addPickgrouparea, payload);
      if (callback) callback(response);
    },
    *pagePickgrouparea({payload,callback},{call, put}){
      const response = yield call(pagePickgrouparea, payload);
      if (callback) callback(response);
    },
    *removePickgrouparea({payload,callback},{call, put}){
      const response = yield call(removePickgrouparea, payload);
      if (callback) callback(response);
    },
    *adjustPickgrouparea({payload,callback},{call, put}){
      const response = yield call(adjustPickgrouparea, payload);
      if (callback) callback(response);
    },
    *verifyDelete({payload,callback},{call, put}){
      const response = yield call(verifyDelete, payload);
      if (callback) callback(response);
    }
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid,
        entityCode: action.entityCode
      }
    }
  },
}
